import React, { useState } from 'react';

function LoginForm({ onLogin, onRegister, error, successMessage }) {
  const [isRegistering, setIsRegistering] = useState(false);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [email, setEmail] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (isRegistering) {
      onRegister(username, password, confirmPassword, email);
    } else {
      onLogin(username, password);
    }
  };

  const toggleMode = () => {
    setIsRegistering(!isRegistering);
    setUsername('');
    setPassword('');
    setConfirmPassword('');
    setEmail('');
  };

  const formStyle = {
    maxWidth: '400px',
    margin: '100px auto',
    padding: '40px',
    backgroundColor: 'rgba(255, 255, 255, 0.95)',
    backdropFilter: 'blur(10px)',
    borderRadius: '12px',
    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
    border: '1px solid rgba(255, 255, 255, 0.2)'
  };

  const inputStyle = {
    width: '100%',
    padding: '12px',
    margin: '8px 0',
    border: '1px solid #ddd',
    borderRadius: '4px',
    fontSize: '16px',
    boxSizing: 'border-box'
  };

  const buttonStyle = {
    width: '100%',
    padding: '12px',
    background: 'linear-gradient(135deg, #3b82f6 0%, #1e3a8a 100%)',
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    fontSize: '16px',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    fontWeight: 'bold'
  };

  const errorStyle = {
    color: 'red',
    margin: '10px 0',
    textAlign: 'center'
  };

  const successStyle = {
    color: 'green',
    margin: '10px 0',
    textAlign: 'center'
  };

  const linkStyle = {
    color: '#3b82f6',
    textDecoration: 'none',
    cursor: 'pointer',
    background: 'none',
    border: 'none',
    fontSize: '14px',
    fontWeight: '500',
    transition: 'color 0.3s ease'
  };

  return (
    <form onSubmit={handleSubmit} style={formStyle}>
      <h2 style={{ textAlign: 'center', marginBottom: '30px', color: '#333' }}>
        TeleHelp v4 - {isRegistering ? 'Create Account' : 'Agent Login'}
      </h2>
      
      {error && <div style={errorStyle}>{error}</div>}
      {successMessage && <div style={successStyle}>{successMessage}</div>}
      
      <div>
        <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
          Username:
        </label>
        <input 
          style={inputStyle}
          value={username} 
          onChange={e => setUsername(e.target.value)} 
          required 
        />
      </div>

      {isRegistering && (
        <div>
          <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
            Email:
          </label>
          <input 
            style={inputStyle}
            type="email"
            value={email} 
            onChange={e => setEmail(e.target.value)} 
            required 
          />
        </div>
      )}

      <div>
        <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
          Password:
        </label>
        <input 
          style={inputStyle}
          type="password" 
          value={password} 
          onChange={e => setPassword(e.target.value)} 
          required 
        />
      </div>

      {isRegistering && (
        <div>
          <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
            Confirm Password:
          </label>
          <input 
            style={inputStyle}
            type="password" 
            value={confirmPassword} 
            onChange={e => setConfirmPassword(e.target.value)} 
            required 
          />
        </div>
      )}

      <button type="submit" style={buttonStyle}>
        {isRegistering ? 'Create Account' : 'Login'}
      </button>

      <div style={{ textAlign: 'center', marginTop: '20px' }}>
        <button type="button" onClick={toggleMode} style={linkStyle}>
          {isRegistering 
            ? 'Already have an account? Sign in' 
            : 'Need an account? Create one'}
        </button>
      </div>

      {isRegistering && (
        <div style={{ fontSize: '12px', color: '#666', marginTop: '10px', textAlign: 'center' }}>
          New accounts require admin approval before accessing phone lookups.
        </div>
      )}
    </form>
  );
}

export default LoginForm; 